import React, { FunctionComponent } from "react";
import { Box, Text, Button, Link, Image } from "@chakra-ui/react";
import { ListedFeature } from "./ListedFeature";

import graphic from "@/assets/PromoClassroom.svg?url";
import { fonts } from "@/theme/fonts";

export const ClassroomPromo: FunctionComponent = () => {
	return (
		<Box display="flex" flexDir="row" boxShadow="20" borderRadius="md" bg="white" p={8} m={8}>
			<Box flex={1} p={4}>
				<Box>
					<Text fontSize={26} fontFamily={fonts.heading} mb={5}>
						Classroom for Teachers
					</Text>
					<Text fontSize="md" color="neutral.300">
						Classroom provides screen visibility of all devices in class, including BYOD and personal devices, to keep students learning and
						teachers teaching
					</Text>
				</Box>

				<Box my={10}>
					<ListedFeature iconName="fa-eye" title="Outstanding visibility" description="See students activity with screen monitoring" />
					<ListedFeature iconName="fa-file-lines" title="Tailored policies" description="Creates flexible, customisable policies" />
					<ListedFeature
						iconName="fa-gear"
						title="Control of tabs and apps"
						description="Restricts learners' access to specific apps and sites during lesson time"
					/>
					<ListedFeature
						iconName="fa-bell"
						title="Immediate feedback"
						description="Spot inappropriate or off-task internet use as it happens, and redirect attention as needed"
					/>
				</Box>

				<Box>
					<Button
						mr={8}
						onClick={() => {
							window.open("https://www.linewize.com/demo", "_blank");
						}}
					>
						Get access to Classroom
					</Button>
					<Link href="https://www.linewize.com/for-teachers" fontWeight={500} isExternal>
						Learn more
					</Link>
				</Box>
			</Box>

			<Box flex={1} p={4}>
				<Image src={graphic} mx="auto" alt="Content Pillars" />
			</Box>
		</Box>
	);
};
